<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
      <vs-list>
        <vs-list-header title="Dictation을 통해 문장 듣기 능력을 향상시킵니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="ww-jumbotron-content-sentence lg:p-6 p-4 mb-6 rounded-lg text-center" >
        <h5 class="mb-1 text-primary">{{ sentence }}</h5>
      </div>
      <div class="ww-jumbotron-content-translation lg:p-6 p-4 mb-6 rounded-lg text-center" >
        <h5 class="mb-1 text-success">{{ content.translation}}</h5>
      </div>
      <div class="vx-row ml-10 mb-6">
        <div class="vx-col md:w-1/4 w-full mt-3">
            <vs-radio v-model="userAnswer" vs-value="1" @change="check($event)"><h3>{{ content.example[0] }}</h3></vs-radio>
        </div>
        <div class="vx-col md:w-1/4 w-full  mt-3">
            <vs-radio v-model="userAnswer" vs-value="2" @change="check($event)"><h3>{{ content.example[1] }}</h3></vs-radio>
        </div>
        <div class="vx-col md:w-1/4 w-full  mt-3">
            <vs-radio v-model="userAnswer" vs-value="3" @change="check($event)"><h3>{{ content.example[2] }}</h3></vs-radio>
        </div>
        <div class="vx-col md:w-1/4 w-full  mt-3">
            <vs-radio v-model="userAnswer" vs-value="4" @change="check($event)"><h3>{{ content.example[3] }}</h3></vs-radio>
        </div>
      </div>
      <div class="text-center">
        <audio ref="audioPlayer" 
            controls
            v-on:ended="audioFinish" 
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>

    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      userAnswer: 0,
      selectedAnswer: '',
      finished: false,
      hint: false,
      retryCount: 0
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    sentence () {
      if (this.hint) {
        return this.content.sentence
      } else {
        return this.content.dictation
      }
    }
  },
  methods: {
    onReload () {
      this.contentIndex = 0
      this.userAnswer = 0
      this.selectedAnswer = ''
      this.hint = false
      this.retryCount = 0
      this.startAlert()
    },
    check () {
      this.selectedAnswer = this.content.example[this.userAnswer - 1]
      this.checkAnswer()
      //this.openConfirm(this.selectedAnswer)
    },
    checkAnswer () {

      //일부 정답에 대소문자 구분이 안되어있어서 여기서 소문자로 변경 후 정답을 비교한다.
      if (this.content.answer.toLowerCase() === this.selectedAnswer.toLowerCase()) {
        
        this.correct()
        
      } else {
        
        this.inCorrect()

        this.retryCount++
        if (this.retryCount < this.retry) {
          setTimeout(function () {
            this.userAnswer = 0
            this.selectedAnswer = ''
          }.bind(this), 1500)
          return
        } 
      }
      this.addResult(this.content.dictation, this.content.answer, this.selectedAnswer)

      setTimeout(function () {
        this.contentIndex++
        this.onStart()
      }.bind(this), 1500)
    },
    cancelAnswer () {
      this.userAnswer = 0
      this.selectedAnswer = ''
    },
    openConfirm (selectedAnswer) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: '정답확인',
        text: `[${  selectedAnswer  }]을(를) 선택하시겠습니까?`,
        accept: this.checkAnswer,
        cancel: this.cancelAnswer
      })
    },
    onStart () {
      
      if (this.contentIndex === (this.contentsLen)) {
        this.onComplete()
      } else {
        this.userAnswer = 0
        this.selectedAnswer = ''
        this.hint = false
        this.audioPlayer.src = this.content.audio
        this.audioPlayer.play()
      }
    },
    audioFinish () {
    },
    startAlert () {
      this.startStudyDlg('Dictation을 통해 문장 듣기 능력을 향상시킵니다.')
    },
    acceptAlert () {
      this.onStart()
    },
    onHint () {
      this.hint = true
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)

    for (let i = 0; i < contentJson.sentence.length; i++) {
      
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        dictation: contentJson.dictation[i],
        example: contentJson.example[i].split('|'),
        answer: contentJson.answer[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }

    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content-sentence {
    border:1px solid #7367F0;
}
.ww-jumbotron-content-translation {
    border:1px solid #28C76F;
}
.tc-ww-input {
    height: 50px;
    width: 200px;
    font-size: 30px;
    text-align: center;
    letter-spacing:10px;
} 
</style>